var ContactType;
(function (ContactType) {
    ContactType[ContactType["Link"] = 1] = "Link";
    ContactType[ContactType["Mail"] = 2] = "Mail";
    ContactType[ContactType["External"] = 3] = "External";
    ContactType[ContactType["Line"] = 4] = "Line";
})(ContactType || (ContactType = {}));
;
var MenuType;
(function (MenuType) {
    MenuType[MenuType["Head"] = 1] = "Head";
    MenuType[MenuType["Top"] = 2] = "Top";
})(MenuType || (MenuType = {}));
;
export { ContactType, MenuType };
//# sourceMappingURL=enums.js.map